module.exports = __webpack_public_path__ + "img/icon4.1ffba8f6.png";